export function isEdge(): boolean {
  return navigator.userAgent.includes("Edg/");
}
